// Deep-link support for creator emails (e.g. the "Review & Sign Agreement"
// email links to /creator-login?next=/mainlayout/creator-profile). Only
// in-app /mainlayout/* paths are honoured — never an absolute or
// protocol-relative URL — so ?next= can't be used as an open redirect.
export function safeNextPath(search) {
  const next = new URLSearchParams(search || "").get("next");
  if (!next) return null;
  if (!next.startsWith("/mainlayout/") || next.startsWith("//") || next.includes("\\")) {
    return null;
  }
  return next;
}
